<template>
<div class="bank-app body" :dir="isRTL ? 'rtl' : 'ltr'">

<Navbar :show-back-button="true" @back="navigateToDashboard"/>

<div class="account-summary">
  <div class="account-type">{{ $t('kala.totalItems') }}</div>

  <div class="account-balance">
    <span class="balance-label"></span>
    <span class="balance-amount">
      {{ totalItems }} {{ $t('kala.itemsUnit') }}
    </span>
  </div>
</div>


<div class="section-header">
  <!-- <button class="back-arrow" @click="navigateToDashboard">→</button> -->

  <h3 class="section-title mt-3" style="margin-right: 10px;">
    {{ $t('kala.listTitle') }}
  </h3>
</div>


<!-- ACTION BAR -->

<div class="action-bar">

  <button class="print-btn" @click="printData">🖨️</button>

  <button class="refresh-btn" @click="fetchKalaData" :disabled="loading">
    🔄
    <span class="refresh-text">{{ $t('common.refresh') }}</span>
  </button>

  <button class="filter-btn" @click="toggleFilterPanel" :title="$t('filters.title')">
    🎛️
    <span class="filter-text">{{ $t('filters.filter') }}</span>

    <span v-if="activeFilterCount > 0" class="filter-badge">
      {{ activeFilterCount }}
    </span>
  </button>

  <div class="search-container">
    <input
      type="text"
      v-model="searchQuery"
      :placeholder="$t('kala.searchPlaceholder')"
      class="search-input"
    />
    <span class="search-icon">🔍</span>
  </div>

</div>


<!-- FILTER PANEL -->

<div v-if="showFilterPanel" class="filter-panel">

<div class="filter-header">
  <h4>{{ $t('kala.filterTitle') }}</h4>
  <button class="close-filter-btn" @click="closeFilterPanel">×</button>
</div>

<div class="filter-content">

<!-- DATE RANGE -->

<div class="filter-group">
<label class="filter-label">{{ $t('filters.dateRange') }}</label>

<div class="date-inputs">

<div class="date-input">
<label>{{ $t('filters.fromDate') }}</label>

<DatePicker
v-model="filters.dateFrom"
format="jYYYY/jMM/jDD"
display-format="jYYYY/jMM/jDD"
:placeholder="$t('filters.selectDate')"
:editable="true"
input-class="persian-date-picker"
:auto-submit="true"
/>

</div>

<div class="date-input">
<label>{{ $t('filters.toDate') }}</label>

<DatePicker
v-model="filters.dateTo"
format="jYYYY/jMM/jDD"
display-format="jYYYY/jMM/jDD"
:placeholder="$t('filters.selectDate')"
:editable="true"
input-class="persian-date-picker"
:auto-submit="true"
/>

</div>

</div>
</div>


<!-- AMOUNT RANGE -->

<div class="filter-group">
<label class="filter-label">{{ $t('filters.amountRange') }}</label>

<div class="amount-inputs">

<div class="amount-input">
<label>{{ $t('filters.from') }}</label>

<input
type="number"
v-model="filters.amountFrom"
:placeholder="$t('filters.zero')"
class="amount-picker"
/>

</div>

<div class="amount-input">
<label>{{ $t('filters.to') }}</label>

<input
type="number"
v-model="filters.amountTo"
placeholder="∞"
class="amount-picker"
/>

</div>

</div>
</div>


<!-- KALA TYPE -->

<div class="filter-group">

<label class="filter-label">
{{ $t('kala.kalaType') }}
</label>

<div class="filter-options">

<label class="filter-option">
<input type="checkbox" v-model="filters.kalaTypes" value="finished">
<span class="checkmark"></span>
{{ $t('kala.types.finished') }}
</label>

<label class="filter-option">
<input type="checkbox" v-model="filters.kalaTypes" value="raw">
<span class="checkmark"></span>
{{ $t('kala.types.raw') }}
</label>

<label class="filter-option">
<input type="checkbox" v-model="filters.kalaTypes" value="semi-finished">
<span class="checkmark"></span>
{{ $t('kala.types.semiFinished') }}
</label>

</div>
</div>


<!-- FILTER ACTIONS -->

<div class="filter-actions">

<button class="apply-filters-btn" @click="applyFilters">
{{ $t('filters.apply') }}
</button>

<button class="clear-filters-btn" @click="clearFilters">
{{ $t('filters.clear') }}
</button>

</div>

</div>
</div>


<!-- ACTIVE FILTERS -->

<div v-if="activeFilterCount > 0" class="active-filters">

<div class="active-filters-header">
<span>{{ $t('filters.activeFilters') }}</span>

<button class="clear-all-filters" @click="clearFilters">
{{ $t('filters.clearAll') }}
</button>

</div>

</div>


<!-- LOADING -->

<div v-if="loading" class="loading-state">
<div class="loading-spinner"></div>
<span>{{ $t('kala.loading') }}</span>
</div>


<!-- KALA LIST -->

<div class="kala-section" v-if="filteredData.length > 0">

<div class="kala-grid">

<div
class="kala-card"
v-for="(record,index) in paginatedData"
:key="index"
>

<div class="card-header">

<div class="record-detail">

<span class="detail-label" style="width:100%;display:flex;justify-content:space-between;align-items:center;">

<span class="record-title">{{ record.NameKala }}</span>

<div class="amount-section">
<span class="record-amount">
{{ record.Tedad }} {{ record.Vahed }}
</span>
</div>

</span>

</div>

</div>


<div class="card-body">

<div class="record-detail">

<div class="comment-section">
<span class="detail-value">
{{ $t('kala.code') }}: {{ record.CodeKala }}
</span>
</div>

<span class="record-date">
{{ formatPersianDate(record.Tarikh) }}
</span>

</div>


<div class="kala-details">

<div class="detail-row">

<span class="detail-label">
{{ $t('kala.amount') }}
</span>

<span class="detail-value">
{{ formatCurrency(record.Mablagh) }} {{ $t('currency.rial') }}
</span>

</div>

</div>


<button
class="details-btn"
@click="openKalaDetails(record)"
:title="$t('kala.viewDetails')"
>

{{ $t('kala.details') }}

</button>

</div>

</div>

</div>


<!-- PAGINATION -->

<div class="pagination-controls">

<button
@click="prevPage"
:disabled="currentPage===1"
class="pagination-btn"
>
{{ $t('pagination.prev') }}
</button>

<span class="page-info">
{{ $t('pagination.page') }} {{ currentPage }}
{{ $t('pagination.of') }}
{{ totalPages }}
</span>

<button
@click="nextPage"
:disabled="currentPage===totalPages"
class="pagination-btn"
>
{{ $t('pagination.next') }}
</button>

</div>

</div>


<!-- EMPTY STATES -->

<div v-if="!loading && filteredData.length===0 && kalaData.length>0" class="e-state">
<span>{{ $t('kala.noSearchResults') }} "{{ searchQuery }}"</span>
</div>

<div v-if="!loading && kalaData.length===0" class="empty-state">
<span>{{ $t('kala.noItems') }}</span>
</div>

</div>
</template>

<script>
import { computed, ref, onMounted, watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { accountingService } from '@/services/api' // Import the service
import Navbar from '@/components/Navbar.vue'
import { useRouter } from 'vue-router'
import DatePicker from 'vue3-persian-datetime-picker'

export default {
  name: 'KalaView',
  components: {
    Navbar,
    DatePicker
  },
  setup() {
    const authStore = useAuthStore()
    const kalaData = ref([])
    const loading = ref(false)
    const error = ref(null)
    const searchQuery = ref('')
    const currentPage = ref(1)
    const itemsPerPage = 10
    const showKalaModal = ref(false)
    const selectedKala = ref(null)
    const router = useRouter()

    // Add filter states
    const showFilterPanel = ref(false)
    const filters = ref({
        dateFrom: '',
        dateTo: '',
        amountFrom: '',
        amountTo: '',
        kalaTypes: [] // ['finished', 'raw', 'semi-finished']
    })

    // Fetch kala data from backend
    const fetchKalaData = async () => {
      if (!authStore.user?.subCodeId) {
        console.error('No customer ID found')
        return
      }

      loading.value = true
      error.value = null

      try {
        console.log('Fetching kala data from backend...')
        
        // You might need to adjust the AC parameter based on your business logic
        const acValue = 6 // Default AC value, adjust as needed
        
        const response = await accountingService.getKalaO(acValue)
        if (response.data.success) {
          // Map backend fields to frontend field names
          kalaData.value = response.data.data.map(item => ({
            // Map backend fields to your frontend field names
            Tarikh: item.Dates, // تاریخ
            Amal: item.NameAct, // عمل
            NameKala: item.KalaName, // نام کالا
            Tedad: item.Value1, // تعداد
            Vahed: item.vahed, // واحد
            Fee: item.fe, // فی
            Mablagh: item.Money, // مبلغ
            FeeArzi: item.Fe_A, // فی ارزی
            MablaghArzi: item.Money_A, // مبلغ ارزی
            CodeKala: item.commodity_code, // کد کالا
            Coding: item.codeing, // کدینگ
            RowNumber: item.idd, // شماره سطر
            MabnaFactor: item.id_Invoice, // مبنای فاکتور
            NoeArz: item.Invoice_Arz, // نوع ارز
            Act: item.act // عمل (additional field)
          }))
          
          console.log('Kala data fetched from backend:', kalaData.value.length, 'records')
        } else {
          error.value = response.data.message || 'خطا در دریافت اطلاعات کالاها'
        }

      } catch (err) {
        console.error('Error fetching kala data:', err)
        error.value = err.response?.data?.detail || 'خطا در دریافت اطلاعات'
      } finally {
        loading.value = false
      }
    }

    // Filter functions
    const toggleFilterPanel = () => {
      showFilterPanel.value = !showFilterPanel.value
    }

    const closeFilterPanel = () => {
      showFilterPanel.value = false
    }

    const applyFilters = () => {
      currentPage.value = 1
      closeFilterPanel()
    }

    const clearFilters = () => {
      filters.value = {
        dateFrom: '',
        dateTo: '',
        amountFrom: '',
        amountTo: '',
        kalaTypes: []
      }
      currentPage.value = 1
    }

    // Count active filters
    const activeFilterCount = computed(() => {
      let count = 0
      if (filters.value.dateFrom) count++
      if (filters.value.dateTo) count++
      if (filters.value.amountFrom) count++
      if (filters.value.amountTo) count++
      if (filters.value.kalaTypes.length > 0) count++
      return count
    })

    const getKalaTypeText = () => {
      if (filters.value.kalaTypes.length === 3) return 'همه'
      return filters.value.kalaTypes.map(type => {
        const texts = {
          'finished': 'کالای ساخته شده',
          'raw': 'مواد اولیه',
          'semi-finished': 'نیمه ساخته'
        }
        return texts[type] || type
      }).join('، ')
    }

    const formatFilterDate = (dateString) => {
      if (!dateString) return ''
      
      try {
        const parts = dateString.split('/')
        if (parts.length !== 3) return dateString
        
        const year = parts[0]
        const month = parseInt(parts[1])
        const day = parts[2]
        
        const persianMonths = [
          'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
          'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
        ]
        
        if (month >= 1 && month <= 12) {
          return `${day} ${persianMonths[month - 1]} ${year}`
        }
        
        return dateString
      } catch {
        return dateString
      }
    }

    // Enhanced filter function
    const filteredData = computed(() => {
      let filtered = kalaData.value

      // Apply search filter
      if (searchQuery.value.trim()) {
        const query = searchQuery.value.trim().toLowerCase()
        filtered = filtered.filter(record => {
          const nameKala = (record.NameKala || '').toString().toLowerCase()
          const codeKala = (record.CodeKala || '').toString().toLowerCase()
          
          return nameKala.includes(query) || codeKala.includes(query)
        })
      }

      // Apply date range filter
      if (filters.value.dateFrom) {
        const fromDate = persianToGregorian(filters.value.dateFrom)
        if (fromDate) {
          fromDate.setHours(0, 0, 0, 0)
          filtered = filtered.filter(record => {
            if (!record.Tarikh) return false
            const recordDate = persianToGregorian(record.Tarikh)
            return recordDate && recordDate >= fromDate
          })
        }
      }

      if (filters.value.dateTo) {
        const toDate = persianToGregorian(filters.value.dateTo)
        if (toDate) {
          toDate.setHours(23, 59, 59, 999)
          filtered = filtered.filter(record => {
            if (!record.Tarikh) return false
            const recordDate = persianToGregorian(record.Tarikh)
            return recordDate && recordDate <= toDate
          })
        }
      }

      // Apply amount range filter
      if (filters.value.amountFrom) {
        const minAmount = parseFloat(filters.value.amountFrom)
        filtered = filtered.filter(record => {
          const amount = record.Mablagh || 0
          return amount >= minAmount
        })
      }

      if (filters.value.amountTo) {
        const maxAmount = parseFloat(filters.value.amountTo)
        filtered = filtered.filter(record => {
          const amount = record.Mablagh || 0
          return amount <= maxAmount
        })
      }

      // Apply kala type filter
      if (filters.value.kalaTypes.length > 0) {
        filtered = filtered.filter(record => {
          const type = determineKalaType(record)
          return filters.value.kalaTypes.includes(type)
        })
      }

      return filtered
    })

    // Helper function to determine kala type
    const determineKalaType = () => {
      // This is a simplified example - implement your actual logic here
      const types = ['finished', 'raw', 'semi-finished']
      return types[Math.floor(Math.random() * types.length)]
    }

    // Persian date utility functions
    const persianToGregorian = (persianDate) => {
      if (!persianDate) return null
      try {
        const parts = persianDate.split('/')
        if (parts.length !== 3) return null
        
        const pYear = parseInt(parts[0])
        const pMonth = parseInt(parts[1])
        const pDay = parseInt(parts[2])
        
        const gDate = new Date(pYear + 621, pMonth - 1, pDay)
        gDate.setMonth(gDate.getMonth() - 1)
        gDate.setDate(gDate.getDate() + 1)
        
        return gDate
      } catch {
        return null
      }
    }

    // Calculate total items
    const totalItems = computed(() => {
      return kalaData.value.length
    })

    // Paginated data
    const paginatedData = computed(() => {
      const startIndex = (currentPage.value - 1) * itemsPerPage
      const endIndex = startIndex + itemsPerPage
      return filteredData.value.slice(startIndex, endIndex)
    })

    // Total pages
    const totalPages = computed(() => {
      return Math.ceil(filteredData.value.length / itemsPerPage)
    })

    // Pagination methods
    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++
      }
    }

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--
      }
    }

    // Reset to first page when search changes
    watch(searchQuery, () => {
      currentPage.value = 1
    })

    const formatCurrency = (amount) => {
      if (!amount && amount !== 0) return '۰'
      return new Intl.NumberFormat('fa-IR').format(amount)
    }

    const formatPersianDate = (dateString) => {
      if (!dateString) return 'تاریخ نامعلوم'
      
      try {
        const parts = dateString.split('/')
        if (parts.length !== 3) return dateString
        
        const year = parts[0]
        const month = parseInt(parts[1])
        const day = parts[2]
        
        const persianMonths = [
          'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
          'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
        ]
        
        if (month >= 1 && month <= 12) {
          return `${day} ${persianMonths[month - 1]} ${year}`
        }
        
        return dateString
      } catch {
        return dateString
      }
    }

    const navigateToDashboard = () => {
      router.push('/dashboard')
    }

    const openKalaDetails = (kala) => {
      selectedKala.value = kala
      showKalaModal.value = true
    }

    const closeKalaModal = () => {
      showKalaModal.value = false
      selectedKala.value = null
    }

    const printData = () => {
      const printWindow = window.open('', '_blank')
      const tableContent = generatePrintableTable()
      
      printWindow.document.write(`
        <html dir="rtl">
          <head>
            <title>چاپ اطلاعات کالاها</title>
            <style>
              body { 
                font-family: Tahoma, Arial, sans-serif; 
                margin: 20px;
                direction: rtl;
              }
              h1 { 
                text-align: center; 
                color: #333;
                margin-bottom: 20px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 10px;
              }
              th, td {
                border: 1px solid #ddd;
                padding: 8px;
                text-align: right;
              }
              th {
                background-color: #f5f5f5;
                font-weight: bold;
              }
              .amount { 
                font-weight: bold;
                color: #2d3436;
              }
              @media print {
                body { margin: 0; }
                table { width: 100%; }
              }
            </style>
          </head>
          <body>
            <h1>گزارش کالاهای شما</h1>
            <div>تاریخ چاپ: ${new Date().toLocaleDateString('fa-IR')}</div>
            <div>تعداد کالاها: ${filteredData.value.length}</div>
            ${tableContent}
          </body>
        </html>
      `)
      
      printWindow.document.close()
      printWindow.focus()
      setTimeout(() => {
        printWindow.print()
      }, 500)
    }

    const generatePrintableTable = () => {
      return `
        <table>
          <thead>
            <tr>
              <th>نام کالا</th>
              <th>کد کالا</th>
              <th>تعداد</th>
              <th>واحد</th>
              <th>فی</th>
              <th>مبلغ</th>
              <th>تاریخ</th>
              <th>عمل</th>
            </tr>
          </thead>
          <tbody>
            ${filteredData.value.map(record => `
              <tr>
                <td>${record.NameKala || '-'}</td>
                <td>${record.CodeKala || '-'}</td>
                <td>${record.Tedad}</td>
                <td>${record.Vahed}</td>
                <td class="amount">${formatCurrency(record.Fee)} ریال</td>
                <td class="amount">${formatCurrency(record.Mablagh)} ریال</td>
                <td>${formatPersianDate(record.Tarikh)}</td>
                <td>${record.Amal || '-'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      `
    }

    const printKalaDetails = () => {
      if (!selectedKala.value) return
      
      const printWindow = window.open('', '_blank')
      const kala = selectedKala.value
      
      printWindow.document.write(`
        <html dir="rtl">
          <head>
            <title>چاپ جزئیات کالا - ${kala.NameKala}</title>
            <style>
              body { 
                font-family: Tahoma, Arial, sans-serif; 
                margin: 20px;
                direction: rtl;
                line-height: 1.6;
              }
              .print-header { 
                text-align: center; 
                color: #333;
                margin-bottom: 30px;
                padding-bottom: 15px;
                border-bottom: 2px solid #667eea;
              }
              .detail-section {
                margin-bottom: 20px;
              }
              .section-title {
                color: #333;
                border-bottom: 1px solid #ddd;
                padding-bottom: 5px;
              }
              .info-box {
                background: #f8f9fa;
                padding: 15px;
                border-radius: 8px;
                margin-top: 10px;
              }
              .info-row {
                display: flex;
                justify-content: space-between;
                padding: 8px 0;
                border-bottom: 1px solid #e0e0e0;
              }
              .info-row:last-child {
                border-bottom: none;
              }
              .info-label {
                font-weight: bold;
                color: #555;
              }
              .info-value {
                color: #333;
              }
              .amount {
                font-weight: bold;
                color: #2d3436;
              }
              @media print {
                body { margin: 0; }
              }
            </style>
          </head>
          <body>
            <div class="print-header">
              <h1>جزئیات کالا: ${kala.NameKala}</h1>
              <div>تاریخ چاپ: ${new Date().toLocaleDateString('fa-IR')}</div>
            </div>
            
            <div class="detail-section">
              <h3 class="section-title">اطلاعات اصلی</h3>
              <div class="info-box">
                <div class="info-row">
                  <span class="info-label">نام کالا:</span>
                  <span class="info-value">${kala.NameKala || 'نامشخص'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">کد کالا:</span>
                  <span class="info-value">${kala.CodeKala || 'نامشخص'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">تعداد:</span>
                  <span class="info-value">${kala.Tedad} ${kala.Vahed}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">فی:</span>
                  <span class="info-value amount">${formatCurrency(kala.Fee)} ریال</span>
                </div>
                <div class="info-row">
                  <span class="info-label">مبلغ:</span>
                  <span class="info-value amount">${formatCurrency(kala.Mablagh)} ریال</span>
                </div>
              </div>
            </div>

            <div class="detail-section">
              <h3 class="section-title">اطلاعات ارزی</h3>
              <div class="info-box">
                <div class="info-row">
                  <span class="info-label">فی ارزی:</span>
                  <span class="info-value">${formatCurrency(kala.FeeArzi)} ${kala.NoeArz || 'واحد'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">مبلغ ارزی:</span>
                  <span class="info-value">${formatCurrency(kala.MablaghArzi)} ${kala.NoeArz || 'واحد'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">نوع ارز:</span>
                  <span class="info-value">${kala.NoeArz || 'نامشخص'}</span>
                </div>
              </div>
            </div>

            <div class="detail-section">
              <h3 class="section-title">اطلاعات تکمیلی</h3>
              <div class="info-box">
                <div class="info-row">
                  <span class="info-label">تاریخ:</span>
                  <span class="info-value">${formatPersianDate(kala.Tarikh)}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">عمل:</span>
                  <span class="info-value">${kala.Amal || 'نامشخص'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">کدینگ:</span>
                  <span class="info-value">${kala.Coding || 'نامشخص'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">شماره سطر:</span>
                  <span class="info-value">${kala.RowNumber || 'نامشخص'}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">مبنای فاکتور:</span>
                  <span class="info-value">${kala.MabnaFactor || 'نامشخص'}</span>
                </div>
              </div>
            </div>
          </body>
        </html>
      `)
      
      printWindow.document.close()
      printWindow.focus()
      setTimeout(() => {
        printWindow.print()
      }, 500)
    }

    onMounted(async () => {
      if (authStore.isAuthenticated) {
        console.log("User is authenticated, fetching kala data from backend...")
        await fetchKalaData()
      }
    })

    return {
      loading,
      error,
      searchQuery,
      currentPage,
      totalPages,
      showKalaModal,
      selectedKala,
      totalItems,
      formatCurrency,
      formatPersianDate,
      nextPage,
      prevPage,
      printData,
      openKalaDetails,
      closeKalaModal,
      printKalaDetails,
      navigateToDashboard,
      fetchKalaData,

      showFilterPanel,
      filters,
      activeFilterCount,
      filteredData,
      kalaData,
      paginatedData,
      toggleFilterPanel,
      closeFilterPanel,
      applyFilters,
      clearFilters,
      getKalaTypeText,
      formatFilterDate
    }
  }
}
</script>

<style scoped>
/* Kala specific styles */
.kala-section {
  padding: 15px;
}

.kala-grid {
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
}

.kala-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.kala-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.record-title {
  font-weight: 700;
  color: #2d3436;
  font-size: 1.1rem;
}

.kala-details {
  margin-top: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-row .detail-label {
  font-weight: 600;
  color: #555;
  font-size: 0.9rem;
}

.detail-row .detail-value {
  color: #333;
  font-size: 0.9rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .kala-grid {
    grid-template-columns: 1fr;
  }
  
  .kala-card {
    padding: 15px;
  }
  
  .action-bar {
    flex-direction: column;
    gap: 10px;
  }
  
  .search-container {
    width: 100%;
  }
}

/* Refresh button styles */
.refresh-btn {
  background: linear-gradient(135deg, #00b894 0%, #00a085 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease;
}

.refresh-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 184, 148, 0.3);
}

.refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.refresh-text {
  font-size: 0.8rem;
  color: white
}

.filter-text{
  color: white
}

/* Modal styles for kala details */
.kala-details {
  padding: 10px 0;
}

.kala-details .detail-section {
  margin-bottom: 25px;
}

.kala-details .section-title {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 2px solid #667eea;
}
.bank-app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f5f5f5;
  direction: rtl;
}

.account-type {
  font-size: 16px;
  margin-bottom: 8px;
  margin-left: 5px;
  opacity: 0.9;
}

.account-balance {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.balance-label {
  font-size: 14px;
  opacity: 0.8;
}

.balance-amount {
  font-size: 18px;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
}
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #667eea;
}

.section-title {
  font-size: 1.1rem;
  color: #333;
  margin: 0;
}

.back-arrow {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.back-arrow:hover {
  background-color: #f0f0f0;
}
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 10px;
}

.print-btn {
  background: #2c3e50;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.print-btn:hover {
  background: #34495e;
}

.search-container {
  position: relative;
  width: 300px;
}

.search-input {
  width: 100%;
  padding: 10px 40px 10px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  direction: rtl;
}

.search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.3rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: white;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
}

/* Loading State */
.modal-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #666;
}

.modal-loading .loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error State */
.modal-error {
  text-align: center;
  padding: 40px;
  color: #d63031;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.modal-error h4 {
  margin: 0 0 10px 0;
  color: #d63031;
}

.modal-error p {
  margin: 0 0 20px 0;
  color: #666;
}

.retry-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: transform 0.2s;
}

.retry-btn:hover {
  transform: translateY(-2px);
}

/* Empty State */
.modal-empty {
  text-align: center;
  padding: 40px;
  color: #666;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.modal-empty h4 {
  margin: 0 0 10px 0;
  color: #333;
}

.info-box {
  background: white;
  border-radius: 6px;
  padding: 5px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  width: 100%;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 600;
  color: #555;
  font-size: 0.9rem;
  width: 120px;
  text-align: right;
  flex-shrink: 0;
  margin-left: 10px;
}

.info-value {
  color: #333;
  font-size: 0.9rem;
  text-align: right;
  flex: 1;
  padding-right: 15px;
}

.info-value.amount {
  font-weight: 600;
  color: #2d3436;
}

.info-value.amount.total {
  color: #e74c3c;
  font-size: 1rem;
}

/* Details Button */
.details-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  margin-top: 10px;
  transition: all 0.3s ease;
  width: 100%;
}

.details-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
}

.details-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.close-modal-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.close-modal-btn:hover {
  background: #5a6268;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 10px;
  }
  
  .modal-header {
    padding: 15px;
  }
  
  .modal-body {
    padding: 15px;
  }
  
  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .info-label, .info-value {
    font-size: 0.85rem;
  }
}
.modal-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.print-modal-btn {
  background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}

.print-modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(39, 174, 96, 0.3);
}

/* Update modal header to accommodate the print button */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

/* Ensure the header content is properly aligned */
.modal-header h3 {
  margin: 0;
  font-size: 1.3rem;
  flex: 1;
}

/* Responsive adjustments for mobile */
@media (max-width: 768px) {
  .modal-actions {
    gap: 8px;
  }
  
  .print-modal-btn {
    padding: 6px 12px;
    font-size: 0.8rem;
  }
  
  .modal-header {
    padding: 15px;
  }
}
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #666;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #4a6baf;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #888;
  background: white;
  border-radius: 12px;
  border: 1px dashed #ddd;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .kala-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .kala-card {
    padding: 12px;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .record-amount {
    align-self: flex-end;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .kala-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1025px) {
  .kala-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.record-detail {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}

.comment-section {
  flex: 1;
  min-width: 0;
  text-align: right;
}

.amount-section {
  display: flex;
  align-items: center;
  gap: 1px;
  flex-shrink: 0;
}

.detail-value {
  font-size: 12px;
  color: #333;
  text-align: right;
  word-wrap: break-word;
  display: block;
}

.record-amount {
  font-weight: bold;
  font-size: 1.1rem;
}

.action-bar {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

/* Filter Button */
.filter-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  font-size: 14px;
  position: relative;
}

.filter-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.filter-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #e74c3c;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Filter Panel */
.filter-panel {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 0;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.filter-header h4 {
  margin: 0;
  color: #495057;
}

.close-filter-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6c757d;
}

.filter-content {
  padding: 20px;
}

.filter-group {
  margin-bottom: 20px;
}

.filter-label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #495057;
}

.filter-options {
  display: flex;
  gap: 15px;
}

.filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.filter-option input[type="checkbox"] {
  margin: 0;
}

.date-inputs, .amount-inputs {
  display: flex;
  gap: 15px;
}

.date-input, .amount-input {
  flex: 1;
}

.date-input label, .amount-input label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #6c757d;
}

.date-picker, .amount-picker {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 14px;
}

.filter-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.apply-filters-btn, .clear-filters-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.apply-filters-btn {
  background: #007bff;
  color: white;
}

.clear-filters-btn {
  background: #6c757d;
  color: white;
}

/* Active Filters */
.active-filters {
  background: #e3f2fd;
  border: 1px solid #bbdefb;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 20px;
}

.active-filters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.clear-all-filters {
  background: none;
  border: none;
  color: #e74c3c;
  cursor: pointer;
  font-size: 12px;
}

.active-filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-tag {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 16px;
  padding: 6px 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-tag button {
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
  font-size: 14px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .search-container{
    width: 100%;
  }
  .action-bar {
    flex-direction: row;
    align-items: center;
  }
  
  .date-inputs, .amount-inputs {
    flex-direction: column;
    gap: 10px;
  }
  
  .filter-options {
    flex-direction: column;
    gap: 10px;
  }
  
  .active-filter-tags {
    flex-direction: column;
  }
}

/* Mobile styles */
@media (max-width: 768px) {
    .info-row {
        flex-direction: row;
        align-items: center;
        padding: 10px 0;
    }
    
    .info-label {
        width: 100px;
        text-align: right;
        margin-left: 5px;
        margin-bottom: 0;
        font-size: 0.85rem;
    }
    
    .info-value {
        width: auto;
        text-align: right;
        padding-right: 5px;
        font-size: 0.85rem;
        font-weight: 500;
        flex: 1;
    }
}

/* Filter Panel Styles */
.filter-panel {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin: 10px 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
}

.filter-header h4 {
  margin: 0;
  color: #333;
}

.close-filter-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
}

.filter-content {
  padding: 15px;
}

.filter-group {
  margin-bottom: 20px;
}

.filter-label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
}

.date-inputs, .amount-inputs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.date-input, .amount-input {
  flex: 1;
  min-width: 150px;
}

.date-input label, .amount-input label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #666;
}

.persian-date-picker, .amount-picker {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.filter-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.filter-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

.apply-filters-btn, .clear-filters-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.apply-filters-btn {
  background: #007bff;
  color: white;
}

.clear-filters-btn {
  background: #6c757d;
  color: white;
}

/* Active Filters */
.active-filters {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  margin: 10px 0;
}

.active-filters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.clear-all-filters {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-size: 14px;
}

.active-filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-tag {
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 16px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.filter-tag button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 14px;
}

/* Filter Button with Badge */
.filter-btn {
  position: relative;
}

.filter-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #dc3545;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bank-app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: var(--bg);
}
.kala-section {
  background: var(--bg);
  color: var(--text);
  padding: 16px;
}

.kala-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(280px,1fr));
  gap: 16px;
}

.kala-card {
  background: var(--card-bg);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  transition: var(--transition);
}

.kala-card:hover {
  box-shadow: var(--shadow-md);
}

.record-title {
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--text);
}

.kala-details {
  font-size: 14px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.detail-label {
  color: var(--text-muted);
}

.detail-value {
  color: var(--text);
  font-weight: 500;
}

.action-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.print-btn,
.refresh-btn,
.filter-btn {
  background: var(--primary);
  color: var(--primary-contrast);
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: var(--transition);
}

.print-btn:hover,
.refresh-btn:hover,
.filter-btn:hover {
  background: var(--primary-hover);
}

.search-container {
  position: relative;
  flex: 1;
}

.search-input {
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--input-bg);
  color: var(--text);
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
}

.filter-panel {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 10px;
  margin-bottom: 16px;
}

.filter-header {
  padding: 12px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
}

.filter-header h4 {
  margin: 0;
}

.close-filter-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
}

.filter-content {
  padding: 12px;
}

.filter-group {
  margin-bottom: 14px;
}

.filter-label {
  display: block;
  margin-bottom: 6px;
  color: var(--text-muted);
}

.date-inputs,
.amount-inputs {
  display: flex;
  gap: 8px;
}

.date-input,
.amount-input {
  flex: 1;
  padding: 8px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--input-bg);
  color: var(--text);
}

.filter-option {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text);
}

.filter-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.apply-filters-btn {
  background: var(--primary);
  color: var(--primary-contrast);
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
}

.clear-filters-btn {
  background: var(--danger);
  color: var(--danger-contrast);
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
}

.active-filters {
  margin-bottom: 14px;
}

.active-filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-tag {
  background: var(--tag-bg);
  color: var(--tag-text);
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
}

.filter-tag button {
  background: none;
  border: none;
  color: var(--tag-text);
  margin-left: 4px;
  cursor: pointer;
}

.loading-state {
  text-align: center;
  padding: 40px;
}

.loading-spinner {
  width: 36px;
  height: 36px;
  border: 4px solid var(--border);
  border-top-color: var(--primary);
  border-radius: 50%;
  margin: auto;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: var(--text-muted);
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--overlay);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: var(--card-bg);
  border-radius: 12px;
  width: 90%;
  max-width: 520px;
  box-shadow: var(--shadow-lg);
}

.modal-header {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
}

.close-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
}

.modal-body {
  padding: 16px;
}

.modal-footer {
  padding: 12px 16px;
  border-top: 1px solid var(--border);
  text-align: right;
}

.print-modal-btn {
  background: var(--primary);
  color: var(--primary-contrast);
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
}

.info-box {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.info-label {
  color: var(--text-muted);
}

.info-value {
  color: var(--text);
  font-weight: 500;
}

.empty-state {
  color: var(--text-soft);
  background: var(--card-bg);
  border: 1px dashed var(--border);
}

</style>